import * as authApi from './auth';
import * as userApi from './user';
import * as roleApi from './role';
import * as permissionApi from './permission';
import * as logApi from './log';
import * as withdrawApi from './withdraw';
import * as orderApi from './order';
import * as transactionApi from './transaction';
import * as freezeRecordApi from './freezeRecord';
import * as prechargeOrderApi from './prechargeOrder';
import * as paymentApi from './payment';
import * as chatApi from './chat';
import * as pushApi from './push';
import * as notificationApi from './notification';
import { systemConfigApi } from './systemConfig';
import * as articleApi from './article';
import * as articleTypeApi from './articleType';
import service from '../utils/request';



// 导出service实例
export { service };

// 导出所有API
export const auth = authApi;
export const user = userApi;
export const role = roleApi;
export const permission = permissionApi;
export const log = logApi;
export const withdraw = withdrawApi;
export const order = orderApi;
export const transaction = transactionApi;
export const freezeRecord = freezeRecordApi;
export const prechargeOrder = prechargeOrderApi;
export const payment = paymentApi;
export const chat = chatApi;
export const push = pushApi;
export const notification = notificationApi;
export const systemConfig = systemConfigApi;
export const article = articleApi;
export const articleType = articleTypeApi;

// 默认导出所有API
export default {
  service,
  auth: authApi,
  user: userApi,
  role: roleApi,
  permission: permissionApi,
  log: logApi,
  withdraw: withdrawApi,
  order: orderApi,
  transaction: transactionApi,
  freezeRecord: freezeRecordApi,
  prechargeOrder: prechargeOrderApi,
  payment: paymentApi,
  chat: chatApi,
    push: pushApi,
    notification: notificationApi,
    systemConfig: systemConfigApi,
    article: articleApi,
    articleType: articleTypeApi
};